var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classNames},[_c('IconLink',{attrs:{"url":"https://github.com/Mohammad1745/portfolio-vue","icon":{ prefix: 'fab', iconName: 'github' },"title":"Source Code"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }